import { render, staticRenderFns } from "./selectPattern.vue?vue&type=template&id=0800bdba&"
import script from "./selectPattern.vue?vue&type=script&lang=ts&"
export * from "./selectPattern.vue?vue&type=script&lang=ts&"
import style0 from "./selectPattern.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports